import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from "@angular/router";

@Component({
    selector: 'lib-auth-silent',
    template: `
    <p>Auth silent component works</p>
  `
})
export class AuthSilentComponent implements OnInit {

  authService = inject(AuthService);

  ngOnInit() {
    this.authService.signinSilentCallback();
  }
}
